// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Login from './Components/Login';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Route for the Login page */}
          <Route path="/" element={<Login />} />
        {/* Route for the App page after login */}
          <Route path="/app/*" element={<App />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
